<ion-header no-border>
  <ion-toolbar>

    <ion-title class="text-center color-dark" data-cy="updateProfInfo-form-title">Edit {{title}}</ion-title>

    <ion-buttons slot="start">
      <ion-button ion-button (click)="dismiss()" data-cy="updateProfInfo-toolbar-dismiss">
        <ion-icon color="dark" class="modal-close" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button class="toolbarButton" color="dark" ion-button [disabled]="required && !inputValue" (click)="done()"
        data-cy="updateProfInfo-toolbar-save">
        Save
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="padding">
  <ion-label class="editFieldLabel">{{title}}</ion-label>
  <ion-item lines="none">
    <ion-input mode="ios" autocapitalize="sentences" #mainInput [type]="inputType" [(ngModel)]="inputValue"
      *ngIf="!isPhone && !isWebsite" [maxlength]="maxChars" (keydown)="limitText()" (keyup)="limitText()"
      name="mainInput" data-cy="updateProfInfo-form-input">
    </ion-input>

    <ion-input mode="ios" class="phone text-input text-input-md" type="tel" [(ngModel)]="inputValue" myNumberOnly
      (input)="onPhoneChange($event.target.value)" placeholder="(###) ###-####" max-length="14" #phoneInput
      *ngIf="isPhone" name="phoneInput" data-cy="updateProfInfo-form-input">
    </ion-input>

    <ion-input mode="ios" #websiteInput id="websiteInput" type="url" [(ngModel)]="inputValue" *ngIf="isWebsite"
      [maxlength]="maxChars" (keydown)="limitText()" (keyup)="limitText()" name="websiteInput"
      data-cy="updateProfInfo-form-input">
    </ion-input>
  
    <ion-icon [name]="eyeIcon" item-end *ngIf="showEye" (click)='showHidePassword()' class="passwordIcon"
    data-cy="updateProfInfo-form-password"></ion-icon>

  </ion-item>

  <div class="counter-container">
    <span *ngIf="showMaxChar" class="text-center color-dark" data-cy="updateProfInfo-form-charsLeft"><b>{{maxChars -
        inputValue.length}} characters
        left.</b></span>
  </div>


</ion-content>